export default __webpack_public_path__ + "static/media/6.6dc63804.jpg";